import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EmpleadosService } from '../../services/empleados/empleados.service';

/**
 * Control de personal de campo: las reglas que no son de turno y las ubicaciones de
 * colegios que los asesores marcaron desde la app y esperan aprobación.
 *
 * Los horarios y la tolerancia no están acá: son los turnos de RRHH (botón Turnos).
 */
@Component({
  selector: 'app-control-campo-configuracion',
  templateUrl: './control-campo-configuracion.component.html',
  styleUrls: ['./control-campo-configuracion.component.css'],
  standalone: false
})
export class ControlCampoConfiguracionComponent implements OnInit {

  /** Lo asigna quien abre el modal. */
  id_empresa: number;

  configuracion: any = {};
  propuestas: any[] = [];
  feriados: any[] = [];
  nuevoFeriado: any = { fecha: '', nombre: '' };
  guardando = false;
  cargando = true;

  constructor(public activeModal: NgbActiveModal,
    private empleadosService: EmpleadosService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.empleadosService.obtenerConfiguracionControlCampo(this.id_empresa).subscribe((c: any) => {
      this.configuracion = c || {};
      this.cargando = false;
    });
    this.cargarPropuestas();
    this.cargarFeriados();
  }

  cargarFeriados() {
    this.empleadosService.obtenerFeriadosControlCampo(this.id_empresa).subscribe((lista: any) => {
      this.feriados = Array.isArray(lista) ? lista : [];
    });
  }

  agregarFeriado() {
    if (!this.nuevoFeriado.fecha) {
      this.toastr.warning('Elegí la fecha del feriado.');
      return;
    }
    this.empleadosService.guardarFeriadoControlCampo(this.id_empresa, this.nuevoFeriado).subscribe((res: any) => {
      if (res.tiene_error) {
        this.toastr.error(res.mensaje);
        return;
      }
      this.nuevoFeriado = { fecha: '', nombre: '' };
      this.cargarFeriados();
    });
  }

  eliminarFeriado(feriado: any) {
    this.empleadosService.eliminarFeriadoControlCampo(this.id_empresa, feriado.id).subscribe((res: any) => {
      if (res.tiene_error) {
        this.toastr.error(res.mensaje);
        return;
      }
      this.feriados = this.feriados.filter(f => f !== feriado);
    });
  }

  /** "2026-11-02" → "Lun 02/11/2026", sin pasar por Date para que no se corra el día. */
  fechaFeriado(texto: string): string {
    const [a, m, d] = texto.split('-').map(Number);
    const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    return dias[new Date(a, m - 1, d).getDay()] + ' ' + String(d).padStart(2, '0') + '/' + String(m).padStart(2, '0') + '/' + a;
  }

  cargarPropuestas() {
    this.empleadosService.obtenerUbicacionesPropuestas(this.id_empresa).subscribe((lista: any) => {
      this.propuestas = Array.isArray(lista) ? lista : [];
    });
  }

  guardar() {
    this.guardando = true;
    this.empleadosService.guardarConfiguracionControlCampo(this.id_empresa, this.configuracion).subscribe((res: any) => {
      this.guardando = false;
      if (res.tiene_error) {
        this.toastr.error(res.mensaje);
      } else {
        this.toastr.success(res.mensaje);
      }
    });
  }

  resolver(cliente: any, aprobar: boolean) {
    this.empleadosService.resolverUbicacionPropuesta(cliente.id, aprobar).subscribe((res: any) => {
      if (res.tiene_error) {
        this.toastr.error(res.mensaje);
        return;
      }
      this.toastr.success(res.mensaje);
      this.propuestas = this.propuestas.filter(p => p !== cliente);
    });
  }

  verEnMapa(lat: any, lng: any) {
    window.open('https://www.google.com/maps?q=' + lat + ',' + lng, '_blank');
  }
}
